import { render, staticRenderFns } from "./product-info-drawer.vue?vue&type=template&id=c3183c14&scoped=true&"
import script from "./product-info-drawer.vue?vue&type=script&lang=js&"
export * from "./product-info-drawer.vue?vue&type=script&lang=js&"
import style0 from "./product-info-drawer.vue?vue&type=style&index=0&id=c3183c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3183c14",
  null
  
)

export default component.exports